import {
    FETCH_PIANOTECHCOMPANY_LIST_STARTED,
    FETCH_PIANOTECHCOMPANY_LIST_SUCCEEDED,
    FETCH_PIANOTECHCOMPANY_LIST_FAILED,
    FIND_PIANOTECHCOMPANY_STARTED,
    FIND_PIANOTECHCOMPANY_SUCCEEDED,
    FIND_PIANOTECHCOMPANY_FAILED,
    SAVE_PIANOTECHCOMPANY_STARTED,
    SAVE_PIANOTECHCOMPANY_SUCCEEDED,
    SAVE_PIANOTECHCOMPANY_FAILED,
    RETURN_TO_PIANOTECHCOMPANY_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHCOMPANY,
    PIANOTECHCOMPANY_MODIFIED,
    PIANOTECHCOMPANY_VALIDATE,
} from '../actions/PianoTechCompanyActions';

import {
    LOGIN_VALIDATE_USER_SUCCESS,
} from '../actions/LoginActions';

import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHCOMPANY_LIST,
    VIEW_PIANOTECHCOMPANY_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
    defaultPianoTechCompany,
    MAINTENANCE_TYPE_EDIT,
} from '../app-constants';

const initialState = {
    pianoTechCompanyList: [],
    pianoTechCompany: defaultPianoTechCompany,
    originalPianoTechCompany: defaultPianoTechCompany,
    view: VIEW_PIANOTECHCOMPANY_UPDATE,
    maintenanceType: MAINTENANCE_TYPE_EDIT,

};
const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHCOMPANY_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechCompany list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechCompanyList: [],
            }

        case FETCH_PIANOTECHCOMPANY_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechCompanyList: action.pianoTechCompanyList,
                message: 'PianoTechCompany list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHCOMPANY_LIST_FAILED:

            return {
                ...state,
                pianoTechCompanyList: [],
                message: 'Error trying to retrieve PianoTechCompany list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHCOMPANY_LIST:

            return {
                ...state,
                pianoTechCompany: null,
                originalPianoTechCompany: null,
                message: '',
                view: VIEW_PIANOTECHCOMPANY_LIST
            }

        case SWITCH_EDIT_TYPE_PIANOTECHCOMPANY:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechCompany: action.pianoTechCompany,
            }

        case FIND_PIANOTECHCOMPANY_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechCompany.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechCompany: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
            }

        case FIND_PIANOTECHCOMPANY_SUCCEEDED:

            return {
                ...state,
                pianoTechCompany: action.pianoTechCompany,
                originalPianoTechCompany: action.originalPianoTechCompany,
                message: 'PianoTechCompany successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHCOMPANY_UPDATE,
            }

        case FIND_PIANOTECHCOMPANY_FAILED:

            return {
                ...state,
                pianoTechCompany: null,
                message: 'Error trying to find PianoTechCompany.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHCOMPANY_MODIFIED:

            return {
                ...state,
                pianoTechCompany: action.pianoTechCompany,
                message: '',
            }

        case SAVE_PIANOTECHCOMPANY_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHCOMPANY_SUCCEEDED:

            return {
                ...state,
                pianoTechCompany: action.pianoTechCompany,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                //maintenanceType: MAINTENANCE_TYPE_COMPLETE,
            }

        case SAVE_PIANOTECHCOMPANY_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHCOMPANY_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        case LOGIN_VALIDATE_USER_SUCCESS:

            return {
                ...state,
                pianoTechCompany: action.pianoTechCompany,
                maintenanceType: action.maintenanceType,
            }

        default:
            return state;
    }
}


export default reducerOutput;
